<template>
	<div class="patient" style="position: relative">
		<div style="position: sticky; top:12px; z-index: 100;">
			<Breadcrumbs :items="items" />
			<v-card>
				<v-tabs v-model="tabOpen" centered grow active-class="secondary">
					<v-tab id="patient_personal" href="#personal">
						<v-icon left>face</v-icon>
						<translate>Personal</translate>
					</v-tab>
					<v-tab id="patient_clinic" href="#clinic" v-if="$store.getters.hasRole('terapeut')" :style="$store.getters.tourStep == 'clinic_history' ? {'position': 'relative', 'z-index': 400, 'background': '#FFFFF2'} : ''">
						<v-icon left>favorite</v-icon>
						<translate>Clinic H.</translate>
					</v-tab>
					<v-tab id="patient_monitoring" href="#monitoring" v-if="$store.getters.hasRole('terapeut')">
						<v-icon left>mdi-chart-line</v-icon>
						<translate>Monitoring</translate>
					</v-tab>
					<v-tab id="patient_appointments" href="#appointments" v-if="showAppointments">
						<v-icon left>assignment</v-icon>
						<translate>Appointments</translate>
					</v-tab>
					<v-tab id="patient_management" href="#management">
						<v-icon left>settings</v-icon>
						<translate>Management</translate>
					</v-tab>
				</v-tabs>
			</v-card>
		</div>
		<v-row v-if="loading" no-gutters justify="center" align="center" style="height: 600px">
			<v-progress-circular
				:size="50"
				color="primary"
				indeterminate
			></v-progress-circular>
		</v-row>
		<v-tabs-items v-else v-model="tabOpen" class="mt-2">
			<v-tab-item :transition="false" :reverse-transition="false" value="personal">
				<PatientForm :patient="patient" :edit="true" />
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" value="clinic" v-if="$store.getters.hasRole('terapeut')">
				<PatientClinic :patient="patient" />
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" value="monitoring" v-if="$store.getters.hasRole('terapeut')">
				<PatientMonitoring :patient="patient" />
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" value="appointments" v-if="showAppointments">
				<v-container fluid>
					<PatientAppointments
						:patientId="$route.params.pid"
						:patient="patient"
					/>
				</v-container>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" value="management">
				<PatientManagement :patient="patient" />
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PatientForm from "@/components/patient/PatientForm.vue";
import PatientClinic from "@/components/patient/PatientClinic.vue";
import PatientAppointments from "@/components/patient/PatientAppointments.vue";
import PatientManagement from "@/components/patient/PatientManagement.vue";
import PatientMonitoring from "@/components/patient/PatientMonitoring.vue";
import axios from "axios";
import { mapGetters } from 'vuex'

export default {
	name: "patient",
	components: {
		Breadcrumbs,
		PatientForm,
		PatientClinic,
		PatientAppointments,
		PatientManagement,
		PatientMonitoring
	},
	props: {
		tab: {
			default: "personal"
		}
	},
	data: () => ({
		loading: true,
		patient: {},
		tabOpen: "personal"
	}),
	computed: {
		items() {
			return [
				{
					text: this.patient.name || '...',
					disabled: true
				}
			];
		},
		showAppointments() {
			return (
				this.$store.getters.hasRole("receptionist") &&
				!this.$store.getters.hasRole("manager")
			);
		},
		...mapGetters({
			tourStep: 'tourStepEvent'
		})
	},
	mounted() {
		this.tabOpen = this.tab;
	},
	created() {
		axios
			.get("/patient/" + this.$route.params.pid + "/personal")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
					this.patient = response.data.patient;
					//this.patient.phone = "+351927471726";
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
	},
	watch: {
		tourStep(value) {
			if(value == 'tour-select-clinic-history') {
				let item = document.getElementById("patient_clinic");
				item.click();
			}
		}
	}
};
</script>